<app-animal-details-container [animal]="animal()" [partialHeight]="true" [showLocator]="true">
  <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    @if (!loading) {
      <div class="row">
        @for (relationship of animals(); track relationship?.id) {
          <div class="card p-3">
            <div class="row mb-2">
              <div class="col-8 d-flex justify-content-start align-items-center">
                <app-animal-button [id]="relationship?.id"
                                   [clickable]="false"
                                   [selectableForAlteration]="false"
                                   [selectableForDeletion]="false"
                                   [standalone]="false"/>
              </div>
              <div class="col-4 ">
                @if (canBeParent(relationship)) {
                  <app-generic-button class="mb-1" (click)="markAs(relationship.id, 'parent')" [buttonText]="'Parent of ' + this.animal()?.visualTag" [description]="'Mark as parent'"/>
                }
                @if (canBeChild(relationship)) {
                  <app-generic-button class="" (click)="markAs(relationship.id, 'child')"  [buttonText]="'Child of ' + this.animal()?.visualTag" [description]="'Mark as child'"/>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }

    <app-spinner [loading]="loading"></app-spinner>
  </div>
</app-animal-details-container>
